// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-chat-rate[data-v-ecc676a2]{padding:16px;border-radius:2px;border:1px solid #ddd;min-width:280px;width:50vh;margin:auto}.c-rate-icon[data-v-ecc676a2]{text-align:center}.c-rate-icon__wrap[data-v-ecc676a2]{width:40px;height:40px;display:inline-block;border-radius:20px;background:#f0f0f0}.u-thumb-up[data-v-ecc676a2]{line-height:35px}.u-thumb-down[data-v-ecc676a2]{line-height:40px}.cursor-pointer[data-v-ecc676a2]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
